import React, { useRef } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/forms/Buttons/Button';
import { Document, Page } from 'react-pdf';
import useSnackbar from '../../utils/hooks/useSnackbar';

export default function DocumentUpload({
  applicant,
  setBody,
  nextPage,
  setDocsPartCompleted,
}) {
  // const [doc, setDoc] = useState(null);
  const [t] = useTranslation();
  const fileRef = useRef(null);
  const { addSnackbar } = useSnackbar();
  return (
    <div className='flex h-full flex-col justify-between'>
      <div>
        <div className='mb-2 flex flex-row items-center'>
          <h3 className='mr-4 text-lg font-semibold'>
            {t('signup.birth_photo')}
          </h3>
          <div className=''>
            <Button
              text={t('signup.upload_docs')}
              onClick={() => fileRef.current.click()}
            />
            <input
              hidden
              type='file'
              accept='application/pdf,.pdf'
              ref={fileRef}
              onChange={async (e, d) => {
                const file = e.target.files[0];
                if (file) {
                  // Only a PDF birth certificate is accepted.
                  // `accept` is just a hint for the file picker and the name/type
                  // can lie (photo.jpg renamed to .pdf), so check the file content:
                  // a PDF has the "%PDF-" marker within its first 1024 bytes.
                  const header = await file.slice(0, 1024).text();
                  if (!header.includes('%PDF-')) {
                    addSnackbar(t('errors.only_pdf'), 'error');
                    e.target.value = null;
                    return;
                  }
                  const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                  if (file.size > maxSize) {
                    addSnackbar(t('errors.file_too_large') || 'File size must be less than 5MB', 'error');
                    e.target.value = null; // Reset the input
                    return;
                  }
                  // setDoc(file);
                  setBody((body) => ({
                    ...body,
                    document: file,
                  }));
                }
              }}
            />
          </div>
        </div>
        <div className='mb-4 flex flex-row items-start gap-2 rounded-md border border-blue-500 bg-blue-50 p-2 text-blue-900'>
          <InformationCircleIcon className='w-6 shrink-0 text-blue-600' />
          <p className='text-sm font-semibold'>{t('signup.birth_pdf_info')}</p>
        </div>
        <div>
          {applicant?.document &&
            (applicant?.document?.type?.startsWith('image/') ? (
              <img
                className='h-[24rem]'
                src={URL.createObjectURL(applicant?.document)}
                alt='doc'
              />
            ) : (
              <div className='h-[24rem]'>
                <Document file={applicant?.document}>
                  <Page pageNumber={1} renderTextLayer={false} height={400} />
                </Document>
              </div>
            ))}
        </div>
      </div>
      <div className=''>
        <div className='mt-6 flex flex-row justify-end'>
          {/* <Button type='button' text='Back' color='secondary' /> */}
          <Button
            type='submit'
            text={t('buttons.save')}
            onClick={() => {
              if (applicant?.document) {
                setDocsPartCompleted(true);
                nextPage(3);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}
